module.exports = __webpack_public_path__ + "media/images/obn-730bc2729798f800a558691a0a1d801a.png";